import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import './CustomTabCommon.css';
const AirQualityValuesTab = () => {
    const { t } = useTranslation();
    const rows = [
        {
            key: 'pm25',
            titleFallback: 'PM2.5',
            textFallback: 'Fine particles smaller than 2.5 µm. They can penetrate deep into the lungs. Often the main driver of a bad AQI in cities and during wood smoke / wildfire events.',
        },
        {
            key: 'pm10',
            titleFallback: 'PM10',
            textFallback: 'Coarser particles up to 10 µm (dust, pollen fragments, road abrasion). Less deep into the lungs than PM2.5, but still relevant for respiratory irritation.',
        },
        {
            key: 'o3',
            titleFallback: 'Ozone (O₃)',
            textFallback: 'Ground-level ozone forms from traffic/industry gases in sunlight. Often higher on sunny afternoons; can irritate airways during outdoor sports.',
        },
        {
            key: 'no2',
            titleFallback: 'Nitrogen dioxide (NO₂)',
            textFallback: 'Typically linked to traffic and combustion. Elevated near busy roads; part of the European index calculation.',
        },
        {
            key: 'so2',
            titleFallback: 'Sulphur dioxide (SO₂)',
            textFallback: 'From burning sulphur-containing fuels and some industrial sources. Usually lower in many Western European cities than PM or NO₂.',
        },
        {
            key: 'co',
            titleFallback: 'Carbon monoxide (CO)',
            textFallback: 'Incomplete combustion (traffic, heating). Dangerous in high indoor concentrations; outdoor levels are usually much lower.',
        },
        {
            key: 'dust',
            titleFallback: 'Dust',
            textFallback: 'Mineral / Saharan dust load. Spikes can raise PM values across large regions even far from the source.',
        },
        {
            key: 'uv',
            titleFallback: 'UV index',
            textFallback: 'Sunburn risk index (not an air pollutant). Handy next to outdoor air-quality planning on clear days.',
        },
        {
            key: 'aod',
            titleFallback: 'AOD / visibility',
            textFallback: 'Aerosol Optical Depth describes how “hazy” the atmosphere is. The app maps it to an approximate visibility in km (clear → dense haze).',
        },
        {
            key: 'pollen',
            titleFallback: 'Pollen',
            textFallback: 'Allergy-relevant pollen counts (Europe). Levels are shown per species; the chart tracks the daily peak across types.',
        },
    ];
    return (_jsxs("div", { className: "custom-tab-common", children: [_jsxs("section", { id: "aqv-intro", className: "custom-tab-section", children: [_jsx("h3", { className: "custom-tab-heading", children: t('aqpro.values.intro.title', 'What do the values mean?') }), _jsx("p", { children: t('aqpro.values.intro.text', 'The AQI is a summary index. The pollutant pages and particle chart let you see which component is elevated. Units for particles and gases are typically µg/m³ unless noted otherwise.') })] }), rows.map((row) => (_jsxs("section", { className: "custom-tab-section", children: [_jsx("h3", { className: "custom-tab-heading", children: t(`aqpro.values.${row.key}.title`, row.titleFallback) }), _jsx("p", { children: t(`aqpro.values.${row.key}.text`, row.textFallback) })] }, row.key))), _jsx("section", { id: "aqv-s1", className: "custom-tab-section", children: _jsx("p", { className: "custom-tab-note", children: t('aqpro.values.disclaimer', 'This page is educational, not medical advice. For health decisions follow local official air-quality guidance.') }) })] }));
};
export default AirQualityValuesTab;
